import { RootState } from "core-integration/src/store";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { IElementsById } from "core-integration/src/store/elements/types";
import { IPickLight } from "core-integration/src/store/entries/types";
import { getRules } from "core-integration/src/store/game/reducers";
import { IRules } from "core-integration/src/store/game/types";
import { size } from "polished";
import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import Captain from "../../img/icons/captain.svg?react";

const StyledCaptain = styled(Captain)<IStyledCaptainProps>`
  ${size(24)};
  color: white;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    ${size(23)}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    ${size(27)}
  }
`;

interface IPropsFromState {
  elementsById: IElementsById;
  rules: IRules | null;
}

interface IOwnProps {
  chipName: string | null;
  pick: IPickLight;
}

interface IStyledCaptainProps {
  variant?: string;
}

type Props = IPropsFromState & IOwnProps & IStyledCaptainProps;

const TeamElementIcon: React.FC<Props> = ({ chipName, pick }) => {
  if (chipName && chipName === "phcapt") {
    if (pick.is_captain) return <StyledCaptain />;
  }
  return null;
};

const mapStateToProps = (state: RootState): IPropsFromState => ({
  elementsById: getElementsById(state),
  rules: getRules(state),
});

export default connect(mapStateToProps)(TeamElementIcon);
